import React from "react";

const Solutions = () => {
  return (
    <div className="solutions">
      <div>
        <h3>Trusted by Fortune 100 companies worldwide</h3>
        <div className="d-flex justify-content-center">
          <a href="/" className="btn--base">
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
};

export default Solutions;
